<nb-card size="tiny">
	<nb-card-body>
		<button
			nbButton
			ghost
			class="box-button"
			*ngIf="menuItems"
			[nbContextMenu]="menuItems"
			nbContextMenuTag="user-dropdown"
		>
			<nb-icon icon="more-vertical-outline"></nb-icon>
		</button>
		<div>
			<nb-icon name="person-outline"></nb-icon>
			<p>{{ name }}</p>
		</div>
	</nb-card-body>
</nb-card>
